import Swiper from 'swiper';
import {
    Autoplay,
    Scrollbar,
    Pagination
} from "swiper/modules";
import {reviews} from "./parts/reviews.js";
import {reviews2} from "./parts/reviews-2.js";


export const sliders = ()=> {
    Swiper.use([Autoplay,Scrollbar,Pagination]);

    reviews(Swiper)

    reviews2(Swiper)
}